import Vue from 'vue'
import Vuex from 'vuex'
import '../plugins/axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stats: false,
    shops: null,
    shop: JSON.parse(localStorage.shop || '{}'),
    me: null,
    produtos: [],
    orders: [],
    carts: [],
    pages: 0,
    page: 0,
    alerts: [],
    syncing: false,
    loading: false,
  },
  mutations: {
    setSyncing(state, payload) {
      state.syncing = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setPages(state, payload) {
      state.pages = payload
    },
    addAlert(state, payload) {
      state.alerts.push(payload)
    },
    setPage(state, payload) {
      state.page = payload
    },
    setOrders(state, payload) {
      state.orders = payload
    },
    setProdutos(state, payload) {
      state.produtos = payload
    },
    setCarts(state, payload) {
      state.carts = payload
    },
    setStats(state, payload) {
      state.stats = {
        idades: {},
        generos: {},
        todos_meses: {},
        meses: {},
        todos_dias: {},
        dias: {},
        horarios: {},
        melhores_horas: {},
        horas_top_10: {},
        todos_melhores_dias: {},
        melhores_dias: {},
        dias_top_10: {},
        cidades_top_10: {},
        estados: {},
        week: [],
        total: 0,
        ...payload,
      }
    },
    setMe(state, payload) {
      state.me = payload
    },
    setShop(state, payload) {
      state.shop = payload
      localStorage.shop = JSON.stringify(payload)
    },
    setShops(state, payload) {
      state.shops = payload
      localStorage.shops = JSON.stringify(payload)
    },
  },
  actions: {
    getUser(context) {
      Vue.axios.get('dashboard/me').then(res => {
        context.commit('setMe', res.data.data)
      })
    },
    getOrders(context) {
      Vue.axios.get(`dashboard/orders?page=${context.state.page}`).then(res => {
        context.commit('setOrders', res.data)
        context.commit('setPages', Math.round(res.headers['x-wp-total'] / 50))
      })
    },
    getProdutos(context) {
      Vue.axios.get(`dashboard/produtos?page=${context.state.page}`).then(res => {
        context.commit('setProdutos', res.data)
        context.commit('setPages', Math.round(res.headers['x-wp-total'] / 50))
      })
    },
    setStore(context, payload) {
      Vue.axios.post(`dashboard/shops/${payload}`).then(() => {
        const shop = context.state.shops.find(item => item.id === payload)
        context.commit('setShop', shop)
        context.dispatch('getUser')
        context.dispatch('getStats')
        setTimeout(() => {
          window.location.reload()
        }, 500)
      })
    },
    getStats(context) {
      const generos = {
        0: 'Masculino',
        1: 'Feminino',
      }
      Vue.axios.get('dashboard/relatorio').then(res => {
        context.commit('setStats', {
          total: res.data.pedidos,
          todos_dias: res.data.dias_mes ? res.data.dias_mes.dias_mes : [],
          idades: res.data.idade ? res.data.idade.idade.map(item => {
            item.x = item.x || '--'
            item.y = parseInt(item.y)
            return item;
          }) : [],
          cidades_top_10: res.data.cidades_top_10 ? res.data.cidades_top_10.cidades_top_10.map(item => {
            item.x = item.x || '--'
            item.y = parseInt(item.y)
            return item;
          }) : [],
          cidades: res.data.cidades ? res.data.cidades.cidades.map(item => {
            item.x = item.x || '--'
            item.y = parseInt(item.y)
            return item;
          }) : [],
          estados: res.data.estados ? res.data.estados.estados.map(item => {
            item.x = item.x || '--'
            item.y = parseInt(item.y)
            return item;
          }) : [],
          generos: res.data.genero ? res.data.genero.genero.map(g => {
            g.x = generos[g.x] || '--'
            return g;
          }) : [],
          todos_melhores_dias: res.data.dias ? res.data.dias.dias : [],
          dias_top_10: res.data.dias_top_10 ? res.data.dias_top_10.dias_top_10 : [],
          horarios: res.data.horarios ? res.data.horarios.horarios : [],
          horas_top_10: res.data.horarios_top_10 ? res.data.horarios_top_10.horarios_top_10 : [],
          todos_meses: res.data.meses ? res.data.meses.meses.map(m => {
            m.x = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'][m.x - 1]
            return m
          }) : [],
          week: res.data.dia_semana ? res.data.dia_semana.dia_semana.map((item, index) => {
            item.x = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'][index]
            return item
          }) : [],
        })
      })
    },
  },
  modules: {},
})
